/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import {
  getClientChartDetails,
  getClientHistoryDetails,
  getClientInfoDetails,
  getClientInfoDetailsById,
  getClientPnlHistory,
  getClientPositionsDetails,
} from '../api';
import { ChartPoint } from '../types/chart';
import { ClientHistory, ClientInfo, ClientPnlHistory, ClientPosition, StatusEnum } from '../types/clientDetails';
import { Nullable } from '../utils/types';

type TFollow$State = {
  clientInfo: Nullable<ClientInfo>;
  chart: ChartPoint[];
  isChartFullHistory: boolean;
  pnlHistory: ClientPnlHistory;
  history: ClientHistory[];
  isHistoryFullHistory: boolean;
  positions: ClientPosition[];
};

type UpdateParams = {
  strategyId: Nullable<string>;
  strategyName: string;
  status: StatusEnum;
};

const initialState = {
  clientInfo: null,
  chart: [],
  isChartFullHistory: false,
  pnlHistory: {
    profit: 0,
    history: [],
  },
  history: [],
  isHistoryFullHistory: false,
  positions: [],
};

// @ts-ignore
export const ClientDetails$ = createStore<TFollow$State>(initialState);

const { setChart, setPnlHistory, setHistory, setPositions, setClientInfo, updateClientInfo, reset } = createApi(
  ClientDetails$,
  {
    // @ts-ignore
    setChart: (state, { result, params }) => {
      let chart = [];
      if (result.success) {
        chart = result.result;
      }

      return {
        ...state,
        chart,
        isChartFullHistory: result.success && !params.startDate,
      };
    },
    // @ts-ignore
    setPnlHistory: (state, { result }) => ({
      ...state,
      pnlHistory: result.success
        ? result.result
        : {
            profit: 0,
            history: [],
          },
    }),
    // @ts-ignore
    setHistory: (state, { result, params }) => {
      let history = [];
      if (result.success) {
        history = result.result;
      }

      return {
        ...state,
        history,
        isHistoryFullHistory: result.success && !params.startDate,
      };
    },
    //  @ts-ignore
    setPositions: (state, { result }) => {
      let positions = [];
      if (result.success) {
        positions = result.result;
      }

      return {
        ...state,
        positions,
      };
    },
    // @ts-ignore
    setClientInfo: (state, { result }) => {
      if (result.success) {
        return {
          ...state,
          clientInfo: result.result?.[0] || result.result,
        };
      }

      return {
        ...state,
        clientInfo: {},
      };
    },
    // @ts-ignore
    updateClientInfo: (state, info: UpdateParams) => {
      if (state && state.clientInfo) {
        const clientInfo = { ...state.clientInfo, ...info };
        return { ...state, clientInfo };
      }

      return state;
    },
    // @ts-ignore
    reset: () => {
      return initialState;
    },
  },
);

export const clientDetailsApi = {
  getChart: createEffect<{ agreementId: string; startDate?: string }, {}, {}>().use(getClientChartDetails),
  getPnlHistory: createEffect<{ agreementId: string; period: string }, {}, {}>().use(getClientPnlHistory),
  getHistory: createEffect<{ agreementId: string; sortType?: string; startDate?: string }, {}, {}>().use(
    getClientHistoryDetails,
  ),
  getPositions: createEffect<string, {}, {}>().use(getClientPositionsDetails),
  getClientInfo: createEffect<string, {}, {}>().use(getClientInfoDetails),
  getClientInfoById: createEffect<string, {}, {}>().use(getClientInfoDetailsById),
  updateClientInfo: createEffect<UpdateParams, {}, {}>(),
  reset: createEffect(),
};

sample({
  clock: clientDetailsApi.getChart.done,
  target: setChart,
});

sample({
  clock: clientDetailsApi.getPnlHistory.done,
  target: setPnlHistory,
});

sample({
  clock: clientDetailsApi.getHistory.done,
  target: setHistory,
});

sample({
  clock: clientDetailsApi.getPositions.done,
  target: setPositions,
});

sample({
  clock: clientDetailsApi.getClientInfo.done,
  target: setClientInfo,
});

sample({
  clock: clientDetailsApi.getClientInfo.fail,
  target: reset,
});

sample({
  clock: clientDetailsApi.getClientInfoById.done,
  target: setClientInfo,
});

sample({
  clock: clientDetailsApi.updateClientInfo,
  target: updateClientInfo,
});

sample({
  clock: clientDetailsApi.reset,
  target: reset,
});
